import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral([''], ['']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  margin: 0px 10px;\n  cursor: pointer;\n'], ['\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  margin: 0px 10px;\n  cursor: pointer;\n']);

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon, Tooltip } from '../../..';
import { styles } from 'gipsy-misc';

var Fields = styled.div(_templateObject);

var IconContainer = styled.div(_templateObject2);

var InlineFields = function (_PureComponent) {
  _inherits(InlineFields, _PureComponent);

  function InlineFields() {
    _classCallCheck(this, InlineFields);

    return _possibleConstructorReturn(this, (InlineFields.__proto__ || Object.getPrototypeOf(InlineFields)).apply(this, arguments));
  }

  _createClass(InlineFields, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          fields = _props.fields,
          activateField = _props.activateField;


      return React.createElement(
        Fields,
        { className: 'fields' },
        fields.map(function (field) {
          return !field.isActive ? React.createElement(
            IconContainer,
            { key: 'i-' + field.id },
            React.createElement(Icon, { icon: field.icon, size: 18, disabled: field.disable, onClick: function onClick(e) {
                return activateField(e, field.id);
              } }),
            field.label ? React.createElement(Tooltip, { text: field.label, vs: 30, hs: 18, ignoreOverflow: true, position: 'top right' }) : ''
          ) : '';
        })
      );
    }
  }]);

  return InlineFields;
}(PureComponent);

InlineFields.propTypes = {
  fields: PropTypes.array,
  activateField: PropTypes.func.isRequired
};


export default InlineFields;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/fields/InlineFields/index.js
// module id = 497
// module chunks = 0